import { createRoot } from 'react-dom/client';
import { GridExample } from './table';



// Render your React component instead
const root = createRoot(document.getElementById('reactsrc'));
root.render(<GridExample />);
